import React from 'react';
import { NavLink } from 'react-router-dom';

export default class CmsBannersInner extends React.Component{

    render() {
        return !this.props.banners ? null :
            <>
                <div className="data-section--concentration-total"></div>
                <div className="data-section--balance-img">{this.props.banners.map((x, i) => {
                    const banner = <div className="img-container" key={i}><img src={x.image} alt={x.label} style={{ width: '100%' }} /></div>;
                    return !x.link ?
                        this.props.onClick ?
                            <div key={i} onClick={this.props.onClick} style={{ cursor: 'pointer' }}>{banner}</div> :
                            banner :
                        x.link.toLowerCase().startsWith('http') ?
                            <a href={x.link} key={i} target="_blank">{banner}</a> :
                            <NavLink to={x.link} key={i} target="_blank">{banner}</NavLink>;
                })}</div>
            </>;
    }

};